const ToolTipData = {
  email: {
    text: 'Please provide the email address of the primary contact person for the organization. This email address will be used for communication and verification purposes. It should be an email address that is regularly monitored by the primary contact and allows for reliable correspondence. Please ensure that the email address provided is accurate and up-to-date to facilitate effective communication and verification.',
  },
  naicsCode: {
    text: 'The NAICS (North American Industry Classification System) code is a standardized code used to classify businesses and organizations into specific industries. Please provide the NAICS code that best represents the industry or sector in which your organization operates. If you are unsure of the appropriate NAICS code, you can refer to official NAICS code directories or consult with relevant industry resources. Providing an accurate NAICS code helps categorize your organization correctly and ensures accurate representation on our platform.',
  },
  ein: {
    text: 'The Employer Identification Number (EIN) is also known as a Federal Tax Identification Number is a unique nine-digit number and is used to identify a business entity.',
  },
  nteeCode: {
    text: 'This is the National Taxonomy of Exempt Entities code, which is used to classify non-profit organizations according to their mission or focus. It is a standardized coding system used by the IRS and other government agencies.',
  },
  dnbNumber: {
    text: 'This is the Dun & Bradstreet Number, which is a unique nine-digit identifier assigned to businesses by the Dun & Bradstreet corporation. It is used to track and identify businesses for various purposes, such as credit reporting and marketing.',
  },
  utilityBill: {
    text: "This is a copy of the most recent bill for a utility service (such as electricity, water, or gas) that the organization uses at its primary location. It is used to verify the organization's address and occupancy.",
  },
  legalDocument: {
    text: 'This is a legal document that establishes the formation of the organization and its legal structure. It may be called different things in different jurisdictions, such as articles of incorporation, certificate of organization, or charter.',
  },
  letter: {
    text: "This is a letter issued by the IRS or other regulatory body confirming the organization's tax-exempt status under section 501(c)(3) of the Internal Revenue Code. It is used to prove the organization's tax-exempt status to donors and other stakeholders.",
  },
  license: {
    text: "This is a legal document that confirms the organization's license to operate in a particular industry or field. It may be required for certain types of organizations, such as healthcare providers or educational institutions.",
  },
  taxReturns: {
    text: "This refers to the most recent copies of the organization's tax returns, which are filed annually with the IRS or other tax authority. They provide information about the organization's financial activities and are used to calculate its tax liability.",
  },
  primaryContact: {
    text: "The primary contact is the main point of contact representing the organization in external communications. They should be someone who has direct knowledge of the organization's activities, non-profit status, and affiliations. Please ensure that you enter the name of the primary contact person accurately to facilitate effective communication and verification.",
  },
};

const organizationEmail: JSX.Element = (
  <span>
    <b>Organization Email</b>
    <br />
    {ToolTipData.email.text}
  </span>
);
const naicsCode: JSX.Element = (
  <span>
    <b>Naics Code</b>
    <br />
    {ToolTipData.naicsCode.text}
  </span>
);
const ein: JSX.Element = (
  <span>
    <b>EIN</b>
    <br />
    {ToolTipData.ein.text}
  </span>
);
const nteeCode: JSX.Element = (
  <span>
    <b>NTEE Code</b>
    <br />
    {ToolTipData.nteeCode.text}
  </span>
);
const dnbNumber: JSX.Element = (
  <span>
    <b>DNB Number</b>
    <br />
    {ToolTipData.dnbNumber.text}
  </span>
);
const utilityBill: JSX.Element = (
  <span>
    <b>Utility Bill</b>
    <br />
    {ToolTipData.utilityBill.text}
  </span>
);
const certificationOfFormation: JSX.Element = (
  <span>
    <b>Certification of Formation</b>
    <br />
    {ToolTipData.legalDocument.text}
  </span>
);
const determinationLetter: JSX.Element = (
  <span>
    <b>Determination Letter</b>
    <br />
    {ToolTipData.letter.text}
  </span>
);
const certificationOfLicense: JSX.Element = (
  <span>
    <b>Certification of License</b>
    <br />
    {ToolTipData.license.text}
  </span>
);
const taxReturns: JSX.Element = (
  <span>
    <b>Tax Returns</b>
    <br />
    {ToolTipData.taxReturns.text}
  </span>
);

const primaryContactName: JSX.Element = (
  <span>
    <b style={{ color: 'red' }}>WARNING</b>
    <br />
    {ToolTipData.primaryContact.text}
  </span>
);
export const organizationEmailContent = organizationEmail.props.children;
export const naicsCodeContent = naicsCode.props.children;
export const einContent = ein.props.children;
export const nteeCodeContent = nteeCode.props.children;
export const dnbNumberContent = dnbNumber.props.children;
export const utilityBillContent = utilityBill.props.children;
export const certificationOfFormationContent =
  certificationOfFormation.props.children;
export const determinationLetterContent = determinationLetter.props.children;
export const certificationOfLicenseContent =
  certificationOfLicense.props.children;
export const taxReturnsContent = taxReturns.props.children;
export const primaryContactNameContent = primaryContactName.props.children;
